import * as React from 'react';

export const CurrentUrlContext = React.createContext({
  url: '',
});
